import store from './store'
import status from './status'

export const STORE = {
  ...store
}

export const STATUS = {
  ...status
}



// WEBPACK FOOTER //
// ./src/constants/index.js